import React, { Component } from 'react'
import { withRouter } from '../extensions/withRouter.js';
import InfoBox from '../components/InfoBox.js';
import TitleBar from '../components/TitleBar.js';
import PageBody from '../components/PageBody.js';
import IconButton from '@mui/material/IconButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleUser, faLeftLong, faMicrochip, faVideo, faWifi, faHourglassHalf, faMagnifyingGlass, faCircleCheck, faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import PageFooter from '../components/PageFooter.js';
import LocalPersistency from '../services/LocalPersistency.js';
import AppConfig from '../config.json';
import axios from 'axios';

/**
 * Control MCR page component
 */
class ControlMCRPage extends Component {

    constructor(props) {
        super(props);

        // component state init
        this.state = {
            requestState: null,
            uuid: null,
            statusMessage: null,
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handleSendAnalyzeRequest = this.handleSendAnalyzeRequest.bind(this);
        this.handlePeriodicCheckStatus = this.handlePeriodicCheckStatus.bind(this);

        this.timeoutHandle = null;
    }

    // "cancel" callback - returns to photo documentation page
    handleCancel() {
        if (this.timeoutHandle !== null) {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }
        this.props.navigate('/photo-new', { replace: true });
    }

    handlePeriodicCheckStatus() {
        const storedUUID = this.state.uuid;
        var targetUrl = (window.location.hostname.includes("app.carrier-qa.internal"))
                            ? new URL(AppConfig.backend.mcrBaseUrl + AppConfig.backend.mcrGetStatusEndpoint.replace("{%UUID%}", storedUUID))
                            : new URL(AppConfig.backendDev.mcrBaseUrl + AppConfig.backendDev.mcrGetStatusEndpoint.replace("{%UUID%}", storedUUID));

        axios.get(targetUrl.toString())
            .then(response => {
                const status = response.data.response.data.status;
                console.log('MCR status:', status);
                var newRequestState = this.state.requestState;
                var statusMessage = '';
                if (status === 'enqueued') {
                    newRequestState = 'enqueued';
                } else if (status === 'pending') {
                    newRequestState = 'pending';
                } else if (status === 'ok') {
                    newRequestState = 'ok';
                } else if (status === 'warning') {
                    newRequestState = 'warning';
                    statusMessage = response.data.response.data.description || '';
                }

                this.setState({
                    requestState: newRequestState,
                    statusMessage: statusMessage,
                });
            })
            .catch(error => {
                console.error('Error checking status:', error);
            });

        // continue periodic checking if not yet completed
        if (this.state.requestState !== 'ok' && this.state.requestState !== 'warning') {
            this.timeoutHandle = setTimeout(() => {
                this.handlePeriodicCheckStatus();
            }, 1000);
        }
        else {
            clearTimeout(this.timeoutHandle);
            this.timeoutHandle = null;
        }
    }

    handleSendAnalyzeRequest() {
        const storedMcrId = LocalPersistency.getMcrId();

        this.setState({
            requestState: 'sending',
        });

        // AppConfig contains backend URLs (mcr)
        var targetUrl = (window.location.hostname.includes("app.carrier-qa.internal"))
                            ? new URL(AppConfig.backend.mcrBaseUrl + AppConfig.backend.mcrAnalyzeEndpoint.replace("{%MCR_ID%}", storedMcrId))
                            : new URL(AppConfig.backendDev.mcrBaseUrl + AppConfig.backendDev.mcrAnalyzeEndpoint.replace("{%MCR_ID%}", storedMcrId));

        const userData = LocalPersistency.getUserIdentity();
        const storedDeviceId = LocalPersistency.getDeviceId();
        const storedEvaporatorId = LocalPersistency.getEvaporatorId();
        const storedValveId = LocalPersistency.getValveId();

        axios.post(targetUrl.toString(), {
            deviceId: storedDeviceId,
            userId: `${userData.name} ${userData.surname}, ${userData.id}`,
            evaporatorId: storedEvaporatorId,
            valveId: storedValveId,
            captureInfo: window.navigator.userAgent
        })
            .then(response => {
                this.setState({
                    requestState: 'sent',
                    uuid: response.data.response.data.uuid,
                });

                // start periodic status checking
                this.timeoutHandle = setTimeout(() => {
                    this.handlePeriodicCheckStatus();
                }, 1000);
            })
            .catch(error => {
                console.error('Error sending analyze request:', error);
            });
    }

    render() {

        // user identity is stored in session
        const userData = LocalPersistency.getUserIdentity();
        const storedMcrId = LocalPersistency.getMcrId();
        const storedDeviceId = LocalPersistency.getDeviceId();

        // in case we got here by an accident, navigate back to the index page
        if (typeof userData === 'undefined' || userData === null || typeof storedDeviceId === 'undefined' || storedDeviceId === null) {
            setTimeout(() => {
                this.props.navigate('/', { replace: true });
            }, 1000);

            return (<></>);
        }

        var requestUUID = "7f3d9b2e-3c4a-4e2b-9f1e-123456789abc";
            //this.state.uuid;

        var screenElement = null;
        if (this.state.requestState === null) {
            screenElement = (
                <button className="button-mcr" disabled={this.state.requestState !== null} onClick={this.handleSendAnalyzeRequest}>Pořídit dokumentaci</button>
            );
        } else if (this.state.requestState === 'sending') {
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faWifi} className="pulsatingUp" />
                <p>Odesílání požadavku na analýzu...</p>
            </div>);
        } else if (this.state.requestState === 'sent') { // sent, but not yet enqueued
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faHourglassHalf} className="pulsatingRotate" />
                <p>Čeká se na zařazení do fronty</p>
                <p className="mcr-status">{requestUUID}</p>
            </div>);
        } else if (this.state.requestState === 'enqueued') { // taking camera photos
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faVideo} className="pulsatingRotate" />
                <p>Pořizování fotodokumentace...</p>
                <p className="mcr-status">{requestUUID}</p>
            </div>);
        } else if (this.state.requestState === 'pending') { // waiting for MCR to process and analyze results
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faMagnifyingGlass} className="rotating" />
                <p>Analýza snímků...</p>
                <p className="mcr-status">{requestUUID}</p>
            </div>);
        } else if (this.state.requestState === 'warning') {
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faTriangleExclamation} />
                <p>Analýza odhalila problém!</p>
                <p>{this.state.statusMessage}</p>
                <p className="mcr-status">{requestUUID}</p>
                <button className="button-mcr" onClick={this.handleSendAnalyzeRequest}>Opakovat analýzu</button>
            </div>);
        } else if (this.state.requestState === 'ok') {
            screenElement = (<div>
                <FontAwesomeIcon size="2x" icon={faCircleCheck} />
                <p>Analýza dokončena, vše v pořádku.</p>
                <p className="mcr-status">{requestUUID}</p>
                <button className="button-mcr" onClick={this.handleSendAnalyzeRequest}>Opakovat analýzu</button>
            </div>);
        }

        return (
            <div className="app">
                <TitleBar>Identifikace místa</TitleBar>
                <InfoBox>
                    <table>
                        <tbody>
                            <tr>
                                <th><FontAwesomeIcon icon={faCircleUser} /></th>
                                <td>{userData.name} {userData.surname}</td>
                            </tr>
                            <tr>
                                <th><FontAwesomeIcon icon={faMicrochip} /></th>
                                <td>{storedDeviceId}</td>
                            </tr>
                        </tbody>
                    </table>
                    <hr />
                    <table>
                        <tbody>
                            <tr>
                                <th><FontAwesomeIcon icon={faVideo} /></th>
                                <td>{storedMcrId}</td>
                            </tr>
                        </tbody>
                    </table>
                </InfoBox>
                <PageBody>
                    <div className="full-width">
                        {screenElement}
                    </div>
                </PageBody>
                <PageFooter>
                    <IconButton onClick={this.handleCancel}>
                        <FontAwesomeIcon size="1x" icon={faLeftLong} />
                    </IconButton>
                </PageFooter>
            </div>
        );
    }
}

export default withRouter(ControlMCRPage);
